import {Template} from "../../../../components/template/template.jsx";
import {useParams} from "react-router";
import {FaPlus} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";
import React, {useEffect, useState} from "react";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {useQuery} from "@tanstack/react-query";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import Swal from "sweetalert2";
import ItemList from "./item-list.jsx";
import inspectionItemsService from "../../../../services/web/inspection-items-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import Alert from "../../../../components/alert/alert.jsx";

const types = [
    {label: "Todos", value: "ALL"},
    {label: "Meu agente", value: "USER"},
    {label: "Grupo de operação", value: "GROUPS"},
]

const inspectionItemForm = {
    name: "",
    items: []
}
const InspectionItemsForm = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(inspectionItemForm);
    const navigate = navigateHook();

    const {data: inspectionItem = null, refetch} = useQuery({
        queryKey: ['entity', id],
        queryFn: () => inspectionItemsService.getById(id),
        enabled: !!id
    });

    const {data: isInspectionItemInUse = false, isLoading: isLoadingInspectionItemInUse} = useQuery({
        queryFn: () => inspectionItemsService.isInspectionItemInUse(id),
        enabled: !!id,
        queryKey: ['isInspectionItemInUse', id]
    })

    useEffect(() => {
        if(!inspectionItem) return;

        const items = Array.isArray(inspectionItem?.item) && inspectionItem.item.length > 0
            ? inspectionItem.item
            : [""];

        setData({
            name: inspectionItem.name,
            items: items
        })
    }, [inspectionItem])

    const save = async () => {
        setIsLoading(true);

        const payload = {
            name: data.name,
            item: JSON.stringify(data.items.filter(item => item !== ""))
        };

        try{
            let response = null;
            if(id){
                response = await inspectionItemsService.update(payload, id);
            } else {
                response = await inspectionItemsService.save(payload);
            }
            projectUtils.success(!id);

            if (id) {
                refetch()
                return;
            }

            navigate(`/inspection-items/form/${response.data.id}`, false)
        }
        catch (error) {
            console.error(error);

            const {message} = error.response.data;

            let errMessage = message ?? "Não foi possível salvar.";

            if(errMessage === "name.already.used") errMessage = "Este \"Nome\" já está sendo utilizado."
            projectUtils.swalErrorMessage("", errMessage, "Ok");
        }
        finally {
            setIsLoading(false)
        }
    }

    const destroy = () => {
        Swal.fire({
            title: "Excluir",
            text: `Excluir a vistoria "${inspectionItem.name}"?`,
            icon: "warning",
            confirmButtonText: "Sim",
            confirmButtonColor: "#063A6C",
            cancelButtonText: "Não",
            cancelButtonColor: "#c10007",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                inspectionItemsService.destroy(id)
                    .then(() => {
                        projectUtils.success(true, "Excluído com sucesso");
                        navigate("/inspection-items");
                    })
                    .catch(error => {
                        console.error(error);
                        let message = 'Não foi possível excluir.';
                        if (error.response.status !== 500) {
                            message = error.response.data.message;
                        }
                        projectUtils.swalErrorMessage('', message, 'Ok');
                    });
            }
        });
    }

    return(
        <Template isLoading={isLoading || isLoadingInspectionItemInUse}>
            <Template.Header>
                <Template.Title>Vistoria</Template.Title>
                { !!id &&
                    <Button target="outline-primary" onClick={() => {
                        setData(inspectionItemForm)
                        navigate("/inspection-items/form", false)
                    }}><FaPlus/>Adicionar vistoria</Button>
                }
            </Template.Header>
            <Template.Body>
                <Card>
                    <Card.Body className="flex w-full">
                        <div className="flex-1">
                            <InputForm
                                id="groupName"
                                label="Grupo *"
                                value={data.name}
                                onInput={({target}) => setData(prev => ({...prev, name: target.value}))}
                            />
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mt-2">
                    <Card.Header>
                        <Card.Title>
                            Itens
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="flex flex-col justify-end gap-2">
                        <ItemList items={data.items}
                                  onChange={(newItems) => setData(prev => ({ ...prev, items: newItems }))}
                        />
                    </Card.Body>
                </Card>
                <Card className="mt-2">
                    <Card.Body>
                        <div className="w-full flex justify-end gap-2 items-center">
                            { isInspectionItemInUse &&
                              <Alert target="warning">Não é possível excluir, pois existem veículos dependentes da vistoria.</Alert>
                            }
                            {!!id &&
                                <Button target="danger" disabled={isInspectionItemInUse}  onClick={destroy} actionFeedbackType='delete'>Excluir</Button>
                            }
                            <Button onClick={save} actionFeedbackType='save'>Salvar</Button>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}

export default InspectionItemsForm;